module.exports = __webpack_public_path__ + "static/img/4638_phase_function_Paper_Points.86991a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4638_phase_function_Paper_Points.png
// module id = BL4L
// module chunks = 0